<i18n>
{
	"en": {
		"loadPlanning": "Load Planning",
		"mapView":      "Map view",
		"newOrder":     "New Order",
		"newTrip":      "New Trip",
		"newDeviation": "New deviation",
		"deviationSearch": "Deviation Search",
		"deviations": 	"Deviations",
		"orderSearch":  "Order Search",
		"orders":       "Orders",
		"planning":     "Planning",
		"tripSearch":   "Trip Search",
		"messages" : 	"Messages",
		"trips":        "Trips",
		"unknown":      "Unknown",
		"unknownPackages": "Unknown Packages",
		"failedToFetchTripSearches": "Failed to fetch saved trip searches",
		"failedToFetchOrderSearches": "Failed to fetch saved order searches",
		"failedToFetchLoadPlanningSearches": "Failed to fetch saved load planning searches",
		"searchOrder": "Search order"
	},
	"no": {
		"loadPlanning": "Lastetorg",
		"mapView":      "Kartvisning",
		"newOrder":     "Nytt oppdrag",
		"newTrip":      "Ny tur",
		"newDeviation": "Nytt avvik",
		"deviationSearch": "Avvikssøk",
		"deviations": 	"Avvik",
		"orderSearch":  "Oppdragssøk",
		"messages" : 	"Meldinger",
		"orders":       "Oppdrag",
		"planning":     "Planlegg",
		"tripSearch":   "Tursøk",
		"trips":        "Turer",
		"unknown":        "Ukjent",
		"unknownPackages":        "Ukjente pakker",
		"failedToFetchTripSearches": "Kunne ikke hente lagrede tursøk",
		"failedToFetchOrderSearches": "Kunne ikke hente lagrede oppdragssøk",
		"failedToFetchLoadPlanningSearches": "Kunne ikke hente lagrede lastetorg-søk",
		"searchOrder": "Søk oppdrag"
	}
}
</i18n>
<template>
	<t-nav-layer :company="companyName" :showSlide="showNavMenu" @close="setNavMenuHidden">
		<t-menu>
			<t-menu-nav-group :title="$t('trips')" bold @click="showTripMenuSettings = true">
				<t-menu-nav-item
					:to="{name: 'tripSearch'}"
					:value="$t('tripSearch')"
					icon="trip"
					iconSize="md"
					bold
				/>

				<t-menu-nav-item
					v-for="item in filteredSavedTripSearches"
					:key="item.id"
					:to="{name: 'savedTripSearch', params: {searchId: item.id}}"
					:value="item.label"
					:count="item.count"
					:isNew="item.isNew"
					icon="filter"
					iconType="bp"
				/>

				<t-menu-nav-item
					:value="$t('newTrip')"
					icon="plus"
					iconType="bp"
					iconSize="sm"
					bold
					@click="openNewTripModal"
				/>
			</t-menu-nav-group>

			<t-menu-divider :border="false" large/>

			<t-menu-nav-group
				:title="$t('orders')"
				bold
				@click="showOrderMenuSettings = true"
			>
				<t-menu-nav-item
					:to="{name: 'orderSearch'}"
					:value="$t('orderSearch')"
					icon="order"
					iconSize="md"
					bold
				/>

				<t-menu-nav-item
					v-for="item in filteredSavedOrderSearches"
					:key="item.id"
					:to="{name: 'savedOrderSearch', params: {searchId: item.id}}"
					:value="item.label"
					:count="item.count"
					:isNew="item.isNew"
					icon="filter"
					iconType="bp"
				/>

				<t-menu-nav-item
					:value="$t('newOrder')"
					icon="plus"
					iconType="bp"
					iconSize="sm"
					bold
					@click="openNewOrderModal"
				/>
			</t-menu-nav-group>

			<t-menu-divider :border="false" large/>

			<t-menu-nav-group
				:title="$t('planning')"
				bold
				@click="showLoadPlanningMenuSettings = true"
			>
				<t-menu-nav-item
					:value="$t('loadPlanning')"
					:to="loadPlanningRoute()"
					icon="list"
					iconType="bp"
					bold
				/>
				<t-menu-nav-item
					v-for="item in filteredSavedLoadPlanningSearches"
					:key="item.id"
					:value="item.label"
					:count="item.count"
					:isNew="item.isNew"
					:to="loadPlanningRoute(item.id)"
					icon="filter"
					iconType="bp"
				/>
			</t-menu-nav-group>
			<t-menu-divider :border="false" large/>
			<t-menu-nav-group :title="$t('unknown')" bold>
				<t-menu-nav-item
					:value="$t('unknownPackages')"
					:to="{name: 'unknownSearch'}"
					icon="help"
					iconType="bp"
					bold
				/>
			</t-menu-nav-group>

			<t-menu-divider :border="false" large/>
			<t-menu-nav-group :title="$t('deviations')" bold>
				<t-menu-nav-item
					:value="$t('deviationSearch')"
					:to="{name: 'deviationSearch'}"
					icon="warning-sign"
					iconType="bp"
					bold
				/>
				<t-menu-nav-item
					:value="$t('newDeviation')"
					icon="plus"
					iconType="bp"
					iconSize="sm"
					bold
					@click="openNewDeviationModal"
				/>
			</t-menu-nav-group>

			<t-menu-divider :border="false" large/>
			<t-menu-nav-group title="EDI" bold>
				<t-menu-nav-item
					:value="$t('messages')"
					icon="database"
					iconType="bp"
					bold
					:to="{name: 'edi'}"
				/>
			</t-menu-nav-group>
		</t-menu>

		<OrderMenuSettings :isShown="showOrderMenuSettings" @close="showOrderMenuSettings = false" />
		<TripMenuSettings :isShown="showTripMenuSettings" @close="showTripMenuSettings = false" />
		<LoadPlanningMenuSettings :isShown="showLoadPlanningMenuSettings" @close="showLoadPlanningMenuSettings = false" />

		<template slot="nav-footer-prepend">
			<OrderSearchInput />
		</template>

		<new-trip />
		<new-order />
		<NewDeviation />

	</t-nav-layer>
</template>

<script>
import OrderMenuSettings from '@/modules/saveOrderSearch/Settings.vue';
import TripMenuSettings from '@/modules/saveTripSearch/Settings.vue';
import LoadPlanningMenuSettings from '@/modules/saveLoadPlanningSearch/Settings';
import NewTrip from '@/modules/newTrip/newTrip.vue';
import NewOrder from '@/modules/newOrder/newOrder.vue';
import NewDeviation from '@/modules/newDeviation/NewDeviation.vue';
import OrderSearchInput from '@/modules/loadPlanningList/OrderSearch/OrderSearchInput';
import { eventBus } from '@/core';

import { mapState as savedTripSearchState, mapActions as savedTripSearchActions } from '@/modules/saveTripSearch/store/saveTripSearch.store.js';
import { mapState as savedOrderSearchState, mapActions as savedOrderSearchActions } from '@/modules/saveOrderSearch/store/saveOrderSearch.store.js';
import { mapState as savedLoadPlanningSearchState, mapActions as savedLoadPlanningSearchActions } from '@/modules/saveLoadPlanningSearch/store/saveLoadPlanningSearch.store.js';
import {
	mapState, mapGetters, mapActions
} from 'vuex';

export default {
	components: {
		TripMenuSettings,
		OrderMenuSettings,
		LoadPlanningMenuSettings,
		NewTrip,
		NewOrder,
		NewDeviation,
		OrderSearchInput,
	},
	data() {
		return {
			showTripMenuSettings: false,
			showOrderMenuSettings: false,
			showLoadPlanningMenuSettings: false,
		};
	},
	computed: {
		...mapState(['showNavMenu']),
		...mapGetters('login',
			['company']
		),
		...savedOrderSearchState({ savedOrderSearches: 'savedSearches' }),
		...savedTripSearchState({ savedTripSearches: 'savedSearches' }),
		...savedLoadPlanningSearchState({ savedLoadPlanningSearches: 'savedSearches' }),
		filteredSavedOrderSearches() {
			return this.savedOrderSearches.filter(x => x.mainMenu);
		},
		filteredSavedTripSearches() {
			return this.savedTripSearches.filter(x => x.mainMenu);
		},
		filteredSavedLoadPlanningSearches() {
			return this.savedLoadPlanningSearches.filter(x => x.mainMenu);
		},
		companyName() {
			return this.company ? this.company.displayName : 'Kundenavn';
		}
	},
	watch: {
		$route: {
			immediate: true,
			handler() {
				this.$forceUpdate();
			}
		}
	},
	async mounted() {
		try {
			await this.initTrips();
		} catch (e) {
			this.$notify({
				type: 'error',
				title: this.$t('failedToFetchTripSearches')
			});
		}

		try {
			await this.initOrders();
		} catch (e) {
			this.$notify({
				type: 'error',
				title: this.$t('failedToFetchOrderSearches')
			});
		}

		try {
			await this.initLoadPlanning();
		} catch (e) {
			this.$notify({
				type: 'error',
				title: this.$t('failedToFetchLoadPlanningSearches')
			});
		}
	},
	destroyed() {
		this.dismountTrips();
		this.dismountOrders();
		this.dismountLoadPlanning();
	},
	methods: {
		...mapActions(['setNavMenuHidden']),
		...savedTripSearchActions({
			initTrips: 'init',
			dismountTrips: 'dismount'
		}),
		...savedOrderSearchActions({
			initOrders: 'init',
			dismountOrders: 'dismount'
		}),
		...savedLoadPlanningSearchActions({
			initLoadPlanning: 'init',
			dismountLoadPlanning: 'dismount'
		}),
		openNewTripModal() {
			eventBus.$emit('toggleNewTripModal',true);
		},
		openNewOrderModal() {
			eventBus.$emit('toggleNewOrderModal',true);
		},
		openNewDeviationModal() {
			eventBus.$emit('openNewDeviation');
		},
		loadPlanningRoute(searchId = -1) {
			let defaultView = localStorage.getItem(`loadPlanning/${searchId}/defaultView`);
			let route = {};

			if (defaultView === 'map') {
				route.name = searchId === -1 ? 'loadPlanningMap' : 'savedLoadPlanningMap';
			} else {
				route.name = searchId === -1 ? 'loadPlanningList' : 'savedLoadPlanningList';
			}

			if (searchId !== -1) {
				route.params = { searchId };
			}

			return route;
		},
	}
};
</script>

